<app-alerts></app-alerts>

<div>
   <!--  <div class="row">
<div class="col-12">
		<h5 class="mainTitle">Ретрансляции</h5>
</div>

</div> -->
   

    <div class="row mob-mt-10">
  
      <div class="col-4 col-sm-6 col-md col-ls col-xl ">
  
      <div class="controlsPanelItems">
          <div class="topPanel">
      <button  *ngIf="!fetchLoading"   nbButton status="primary" [nbContextMenu]="createMenu" nbContextMenuTag="restream-create-menu" nbContextMenuPlacement="bottom-end"
      >Створити <nb-icon icon="chevron-down-outline" pack="eva"></nb-icon></button>
 
<ngx-skeleton-loader  *ngIf="fetchLoading"   [theme]="{  width: '200px',   height: '40px' }"></ngx-skeleton-loader>
    </div>
   </div>
    
      </div>
      <div class="col d-none   d-md-block d-lg-block d-xl-block"></div>
      <div class="col d-none   d-md-block d-lg-block d-xl-block"></div>
      <div class="col-8   col-sm-6 col-md col-ls col-xl ">
	<app-grid-density-control *ngIf="!fetchLoading"
		[storageKey]="colsKey"
		(changed)="cols = $event"></app-grid-density-control>
       <!-- <div class="controlsPanelItems"  ><div class="right">
       
        <nb-toggle  labelPosition="left" [(checked)]="showControls" status="primary"><span>Редактировать</span></nb-toggle>
        
    </div>

    </div> -->
      </div>    
  
    </div>
  
  
    <div class="pagesWrapper">
      
        <div *ngIf="!fetchLoading; else skeleton">
   <div class="cardGrid" [ngClass]="'cols-' + cols">
   <!-- 
    <div *ngFor="let stream of streams" class="col col-sm-12 col-md-6  col-lg-4  col-lg-4 col-xl-3 col-item">
-->

  
<div *ngFor="let restream of restreams" class="col-item">
    <div *ngIf="restream.kind === 'srt'" class="overviewStreamCard restreamCard srtCard">
      <div class="itemPreview" (click)="openRestreamModal(restream)">
        <div class="restreamItemBlock" [class.signal]="restream.srt?.hasSignal && !restream.srt?.readers" [class.live]="restream.srt?.readers > 0">
          <div class="lbl"><div><div>SRT</div><div>{{ restream.srt?.hasSignal ? 'signal' : 'no' }}</div></div></div>
        </div>
        <div class="restreamItemBlock">
          <div class="lbl"><div><div>Mbit/s</div><div>{{ restream.srt?.inputMbps || 0 }}</div></div></div>
        </div>
        <div class="restreamItemBlock">
          <div class="lbl"><div><div>Out</div><div>{{ restream.srt?.readers || 0 }}</div></div></div>
        </div>
      </div>
      <div class="title"><div class="title-text" (click)="openRestreamModal(restream)">{{restream.title}}</div>
        <div *ngIf="!restream.srt?.hasSignal" nbContextMenuTag="restream-menu" [nbContextMenu]="[{ title: 'Видалити', item:restream, cmd:'remove'}]" class="title-menu">
          <nb-icon [icon]="'more-vertical-outline'" pack="eva"></nb-icon>
        </div>
      </div>
    </div>
    <div *ngIf="restream.kind !== 'srt'" class="overviewStreamCard restreamCard" >

    <div class="itemPreview"  (click)="openRestreamModal(restream)"  >
       

      <div [class.signal]="restream.hasSignal &&  !restream.runningsCount"
      [class.live]="restream.runningsCount > 0"
      class="restreamItemBlock">
          <div class="lbl">
            <div *ngIf="!restream.hasSignal &&  !restream.isRunning" > 
              <div>
                Signal
              </div>
              <div>no</div>

            </div>

            <div *ngIf="restream.hasSignal &&  !restream.runningsCount" > 
              <div>
                Signal
              </div>
            </div>
             
            <div *ngIf="restream.runningsCount > 0" > 
              <div>
                Restream
              </div>
              

            </div>
             
          </div>

          


      </div>

      <div style="position: relative;" class="restreamItemBlock">

        <div class="signalInfo" *ngIf="restream.signalInfo">
          <app-overview-restreams-info [info]="restream.signalInfo"></app-overview-restreams-info>
        </div>
          <div class="lbl">
            <div> 
              <div>
                Bitrate
              </div>
              <div>{{ restream.bitrate || 0}}</div>

            </div>
            
          </div>
      </div>

      <div class="restreamItemBlock">
        <div class="lbl">
          <div> 
            <div>
              Active
            </div>
            <div>{{restream.runningsCount || 0}} / {{restream.restreams.length}}</div>

          </div>
          
        </div>
      </div>
 
    </div>
   
  
        <div class="top-nav" >
          
          <!--   
          <button nbButton *ngIf="!restream.hasSignal && showControls" (click)="openRemoveModal(deleteModal, restream, $event)" status="danger">Удалить</button>
         -->
        </div>

   
 
        <div>


        </div>


 



 

   <div class="title"><div class="title-text"   (click)="openRestreamModal(restream)"  >{{restream.title}}</div>

			<div *ngIf="!restream.hasSignal" nbContextMenuTag="restream-menu"  [nbContextMenu]="[{ title: 'Видалити', item:restream, cmd:'remove'}]" class="title-menu">

<nb-icon    [icon]="'more-vertical-outline'" pack="eva"></nb-icon>
			</div>

		</div>

        </div>
  </div>

  
  
         
  
        </div>
      </div>
  
  
       <div *ngIf="removeLoading" style="position: fixed; z-index: 777; background-color:rgba(0,0,0,0.5); width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
          <div style="margin: auto;"> 
               <app-loader></app-loader>
           </div>
          </div>
  
        <ng-template #loader>
          <div style="position: fixed; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
          <div style="margin: auto;"> 
               <app-loader></app-loader>
           </div>
          </div>
      </ng-template> 
  
  
   <ng-template #skeleton>
	 
	<app-skeleton-overviews [length]="8" [height]="'76px'" [cols]="cols" ></app-skeleton-overviews> 
  
    </ng-template> 

  
  
  
   
 <ng-template #deleteModal  let-data   let-ref="dialogRef">

    <div style="max-width:400px">
           <nb-card>
        <nb-card-header>
    
      
      <div style="display:flex; width:100%">
        <span>Видалити ретрансляцію?</span>   
         <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
  <nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
      </span>  
      </div>
    </nb-card-header>
        <nb-card-body>
      <div>
          
           
        <p>Увага! Ця дія видалить ретрансляцію і всі пов'язані дані, ви впевнені, що хочете продовжити?</p>
    
      </div>
    </nb-card-body>
        <nb-card-footer>
         
           
      <div style="display:flex; width:100%">
              
              <button style="display:flex; margin-left:auto; cursor: pointer;" (click)="removeSelectedRestream(ref)" nbButton status="danger" >Видалити ретрансляцію</button>
              <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >Скасувати</button>
  
    
            </div>
        </nb-card-footer>
      </nb-card>
       
    </div>
      </ng-template>
      
       
    
  
  
  
  
  
    </div>
   
  </div> 
  
  <!---->
  
  
